import Vue from 'vue';
import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

const options = {
    timeout: 5000,
    position: 'top-center',
    draggable: false
};

Vue.use(Toast, options);
